import { useSelector } from 'react-redux';
import {
  selectMeteorologyAgroCultureIndexLocationGroupId,
  selectMeteorologyAgroCultureIndexLocationLocationId,
  setLocationId,
} from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import { useCallback, useEffect, useMemo } from 'react';
import { store } from 'redux/store';
import useLocations from '../../useLocations';

export default function useLocationOptions() {
  const { locations } = useLocations();
  const selectedGroupId = useSelector(selectMeteorologyAgroCultureIndexLocationGroupId);
  const selectedLocationId = useSelector(selectMeteorologyAgroCultureIndexLocationLocationId);

  const availableLocations = useMemo(() => (
    locations?.filter((location) => location.groupId === selectedGroupId) || []
  ), [locations, selectedGroupId]);

  const setLocation = useCallback((id: number | undefined) => {
    store.dispatch(setLocationId(id));
  }, []);

  useEffect(() => {
    // Só valida se há locais disponíveis carregados e um locationId selecionado
    if (availableLocations.length > 0 && selectedLocationId) {
      const selectedLocation = availableLocations.find((loc) => loc.id === selectedLocationId);
      if (!selectedLocation) {
        setLocation(undefined);
      }
    }
  }, [availableLocations, selectedLocationId, setLocation]);

  return {
    availableLocations,
    selectedLocationId,
    setLocation,
  };
}
